import React, { useEffect, useState } from "react";
import { LoadingDiv } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { documentsAdd, documentsTypeList } from "../../api/CollectionDistribution";
import Swal from "sweetalert2";

export default function StudentDocumentsAdd() {
  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams] =
    useSearchParams();

  const enquiry_id =
    searchParams.get("enquiry_id") || "";

  const student_id =
    searchParams.get("student_id") || "";

  const staff_id =
    searchParams.get("staff_id") || "";




  const [loading, setLoading] = useState(false);

  const [documentsTypes, setDocumentsTypes] = useState([]);


  const [documents, setDocuments] = useState([
    {
      enquiry_id: enquiry_id,
      student_id: student_id,
      staff_id: staff_id,

      document_type_id: "",

      document_number: "",
      school_name: "",
      education_year: "",
      score: "",

      file: "",
    },
  ]);

  // GET DOCUMENT TYPES
  const getDocumentsTypes = async () => {
    try {
      setLoading(true);

      const response = await documentsTypeList("?status=1");

      if (response?.data?.status) {
        const documents =
          response?.data?.data?.data ||
          response?.data?.data ||
          [];

        setDocumentsTypes(
          Array.isArray(documents) ? documents : []
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // HANDLE CHANGE
  const handleDocumentChange = (index, e) => {
    const { name, value, files } = e.target;

    setDocuments((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
            ...item,
            [name]: files ? files[0] : value,
          }
          : item
      )
    );
  };

  // ADD DOCUMENT
  const addDocument = () => {
    setDocuments([
      ...documents,
      {
        enquiry_id: enquiry_id,
        student_id: student_id,
        staff_id: staff_id,

        document_type_id: "",

        document_number: "",
        school_name: "",
        education_year: "",
        score: "",

        file: "",
      },
    ]);
  };

  // REMOVE DOCUMENT
  const removeDocument = (index) => {
    const updatedDocuments = [...documents];

    updatedDocuments.splice(index, 1);

    setDocuments(updatedDocuments);
  };

  // FORM SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(JSON.stringify(documents, null, 2));

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append(
        "enquiry_id",
        enquiry_id
      );

      formData.append(
        "student_id",
        student_id
      );

      formData.append(
        "staff_id",
        staff_id
      );

      // DOCUMENTS DATA
      const documentsData = documents.map(
        (item) => ({
          document_type_id:
            item.document_type_id,

          document_number:
            item.document_number,

          school_name:
            item.school_name,

          education_year:
            item.education_year,

          score: item.score,
        })
      );

      formData.append(
        "documents",
        JSON.stringify(documentsData)
      );

      // FILES
      documents.forEach((item, index) => {
        if (item.file) {
          formData.append(
            `file[${index}]`,
            item.file
          );
        }
      });

      const response =
        await documentsAdd(formData);

      if (response?.data?.status) {

        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.data?.message,
          timer: 2000,
          showConfirmButton: false,
        });

        navigate("/student/documents");
      }

    } catch (error) {

      console.log(error);

    } finally {

      setLoading(false);

    }
  };

  useEffect(() => {
    getDocumentsTypes();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">

                        <h4 className="text-primary">
                          Student Documents Add
                        </h4>

                        <hr />

                        <form onSubmit={handleSubmit}>

                          {documents.map((doc, index) => {

                            // SELECTED DOCUMENT
                            const selectedDocument =
                              documentsTypes.find(
                                (item) =>
                                  item.id ==
                                  doc.document_type_id
                              );

                            // DOCUMENT TYPE
                            const documentType =
                              selectedDocument?.document_type;

                            return (
                              <div
                                className="row g-3 align-items-start mb-4"
                                key={index}
                              >

                                {/* DOCUMENT TYPE */}

                                <div className="col-md-3">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="document_type_id"
                                      value={
                                        doc.document_type_id
                                      }
                                      onChange={(e) =>
                                        handleDocumentChange(
                                          index,
                                          e
                                        )
                                      }
                                    >
                                      <option value="">
                                        Select Document Type
                                      </option>

                                      {documentsTypes.map(
                                        (item) => (
                                          <option
                                            key={item.id}
                                            value={
                                              item.id
                                            }
                                          >
                                            {
                                              item.document_name
                                            }
                                            (
                                            {
                                              item.document_type
                                            }
                                            )
                                          </option>
                                        )
                                      )}
                                    </select>

                                    <label>
                                      Document Type
                                    </label>
                                  </div>
                                </div>

                                {/* IDENTITY */}

                                {documentType ===
                                  "Identity" && (
                                    <>
                                      <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="document_number"
                                            placeholder="Document Number"
                                            value={
                                              doc.document_number
                                            }
                                            onChange={(e) =>
                                              handleDocumentChange(
                                                index,
                                                e
                                              )
                                            }
                                          />

                                          <label>
                                            Document Number
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-3">
                                        <input
                                          type="file"
                                          className="form-control"
                                          name="file"
                                          onChange={(e) =>
                                            handleDocumentChange(
                                              index,
                                              e
                                            )
                                          }
                                        />
                                      </div>
                                    </>
                                  )}

                                {/* MARKSHEET */}

                                {documentType ===
                                  "Marksheet" && (
                                    <>
                                      <div className="col-md-2">
                                        <div className="form-floating form-floating-outline">
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="school_name"
                                            placeholder="School Name"
                                            value={
                                              doc.school_name
                                            }
                                            onChange={(e) => {
                                              console.log("school_name:", e.target.value);
                                              handleDocumentChange(index, e);
                                            }}
                                          />

                                          <label>
                                            School Name
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-1">
                                        <div className="form-floating form-floating-outline">
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="education_year"
                                            placeholder="Year"
                                            value={
                                              doc.education_year
                                            }
                                            onChange={(e) =>
                                              handleDocumentChange(
                                                index,
                                                e
                                              )
                                            }
                                          />

                                          <label>
                                            Year
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-1">
                                        <div className="form-floating form-floating-outline">
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="score"
                                            placeholder="Score"
                                            value={
                                              doc.score
                                            }
                                            onChange={(e) =>
                                              handleDocumentChange(
                                                index,
                                                e
                                              )
                                            }
                                          />

                                          <label>
                                            Score
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-3">
                                        <input
                                          type="file"
                                          className="form-control"
                                          name="file"
                                          onChange={(e) =>
                                            handleDocumentChange(
                                              index,
                                              e
                                            )
                                          }
                                        />
                                      </div>
                                    </>
                                  )}

                                {/* OTHER */}

                                {documentType ===
                                  "Other" && (
                                    <div className="col-md-3">
                                      <input
                                        type="file"
                                        className="form-control"
                                        name="file"
                                        onChange={(e) =>
                                          handleDocumentChange(
                                            index,
                                            e
                                          )
                                        }
                                      />
                                    </div>
                                  )}

                                {/* BUTTONS */}

                                {/* BUTTONS */}

                                <div className="col-md-2 d-flex gap-2">

                                  {/* ADD BUTTON ONLY LAST ROW */}

                                  {index === documents.length - 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-success"
                                      onClick={addDocument}
                                    >
                                      +
                                    </button>
                                  )}

                                  {/* REMOVE BUTTON */}

                                  {documents.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() =>
                                        removeDocument(index)
                                      }
                                    >
                                      -
                                    </button>
                                  )}

                                </div>

                              </div>
                            );
                          })}

                          {/* SAVE BUTTON */}

                          <div className="text-end mt-4">
                            <button
                              type="submit"
                              className="btn btn-primary"
                            >
                              Save
                            </button>
                          </div>

                        </form>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}